import { Box, Container, Stack, Typography, Link as MuiLink } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { SUPPORT_EMAIL } from '@tnf-recruit/shared'
import logo from '../assets/logo.png'

export const PublicFooter = () => {
  return (
    <Box sx={{ bgcolor: 'primary.dark', color: 'common.white', py: 4 }}>
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              component="img"
              src={logo}
              alt=""
              sx={{ height: 36, width: 36, objectFit: 'contain' }}
            />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              T&F All-Star Recruiting
            </Typography>
          </Stack>
          <Stack direction="row" spacing={5} alignItems="center">
            <MuiLink
              href={`mailto:${SUPPORT_EMAIL}`}
              underline="hover"
              sx={{ color: 'grey.300', fontSize: '0.875rem' }}
            >
              {SUPPORT_EMAIL}
            </MuiLink>
            <MuiLink
              component={RouterLink}
              to="/privacy"
              underline="hover"
              sx={{ color: 'grey.300', fontSize: '0.875rem' }}
            >
              Privacy Policy
            </MuiLink>
            <Typography variant="body2" sx={{ color: 'grey.400' }}>
              © {new Date().getFullYear()} T&F All-Star Recruiting. All rights reserved.
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Box>
  )
}
